import { Component, inject } from '@angular/core';
import { TokenExpirationService } from '../../services/token-expiration.service';

@Component({
  selector: 'app-session-expiration-modal',
  standalone: true,
  templateUrl: './session-expiration-modal.html',
  styleUrls: ['./session-expiration-modal.scss']
})
export class SessionExpirationModalComponent {
  tokenService = inject(TokenExpirationService);

  get formattedTime(): string {
    const s = this.tokenService.remainingSeconds();
    const min = Math.floor(s / 60).toString().padStart(2, '0');
    const sec = (s % 60).toString().padStart(2, '0');
    return `${min}:${sec}`;
  }

  onContinue(): void {
    this.tokenService.continueSession();
  }

  onClose(): void {
    this.tokenService.closeSession();
  }
}
